import { countryReference } from './constants/strings';
import moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppInjector } from '../shared/modules/material.module';

const convertUTCtoUserLocalTimeZone = (date, existingTimeZone, timeZone) => {
  return new Date(
    new Date(`${date.replace('T', ' ').replace('Z', ' ')}
  ${existingTimeZone}`).toLocaleString('en-US', { timeZone })
  );
};

const getCurrentGMT = date => {
  return `GMT${moment().tz(date).format().split('T')[1].slice(8)}`;
};

const getUserGMT = () => {
  return moment(new Date().toISOString().split('T')[0]).tz(moment.tz.guess()).format('Z');
};

const getCountryNameByCountryCode = countryCode =>
  countryReference.find(item => item?.code === countryCode);

const dateAppend = (date: string) => {
  return date.length < 2 ? '0' + date : date;
};

const dateMapBetweenDays = (days: number) => {
  const currentDate = new Date();
  const betweenDays = new Date();
  betweenDays.setDate(betweenDays.getDate() - days);

  return {
    fromDate: `${betweenDays.getFullYear()}${dateAppend(
      (betweenDays.getMonth() + 1).toString()
    )}${dateAppend(betweenDays.getDate().toString())}`,
    toDate: `${currentDate.getFullYear()}${dateAppend(
      (currentDate.getMonth() + 1).toString()
    )}${dateAppend(currentDate.getDate().toString())}`,
  };
};

const createSnackBar = (message, action, horizontalPosition, verticalPosition, duration) => {
  const snackBar = AppInjector.get(MatSnackBar);
  snackBar.open(message, action, {
    horizontalPosition,
    verticalPosition,
    duration: duration * 1000,
    panelClass: ['notification-bar'],
  });
};

const dateFilterInDays = (days: number, dateField: string = '') => {
  const currentDate = new Date();
  const betweenDays = new Date();
  betweenDays.setDate(betweenDays.getDate() - days);

  return {
    daterange: {
      datefield: dateField,
      fromdate: `${betweenDays.getFullYear()}${dateAppend(
        (betweenDays.getMonth() + 1).toString()
      )}${dateAppend(betweenDays.getDate().toString())}`,
      todate: `${currentDate.getFullYear()}${dateAppend(
        (currentDate.getMonth() + 1).toString()
      )}${dateAppend(currentDate.getDate().toString())}`,
    },
  };
};

const filterDate = date =>
  `${date.getFullYear()}${dateAppend((date.getMonth() + 1).toString())}${dateAppend(
    date.getDate().toString()
  )}`;

const compareArrayElements = (first, second) => first.some(item => second.includes(item));

const isObjectEmpty = objectName => {
  return Object.keys(objectName).length === 0;
};

const checkObjectExist = (object, key) => object.hasOwnProperty(key);

const postalCodePatternValidation = (countryCode: string, newValue: string) => {
  if (countryCode === 'CA') {
    if (/^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/.test(newValue.trim())) {
      return newValue.trim().substring(0, 7);
    } else {
      return newValue.trim();
    }
  } else if (countryCode == 'GB') {
    if (/^[A-Za-z]{2}\d{2}\s\d[A-Za-z]{2}$/.test(newValue.trim())) {
      return newValue.trim().substring(0, 6);
    } else if (/^[A-Za-z]{2}\d\s\d[A-Za-z]{2}$/.test(newValue.trim())) {
      return newValue.trim().substring(0, 5);
    } else if (/^[A-Za-z]{2}\d[A-Za-z]{1}\s\d[A-Za-z]{2}$/.test(newValue.trim())) {
      return newValue.trim().substring(0, 6);
    } else if (/^[A-Z][0-9]?\s[0-9][A-Z]{2}$/.test(newValue.trim())) {
      return newValue.trim().substring(0, 4);
    } else if (/^[A-Z]{1}\d{2}[\s]?\d{1}[A-Z]{2}$/.test(newValue.trim())) {
      return newValue.trim().substring(0, 5);
    } else if (/^[A-Z]{1}\d{1}[A-Z]{1}[\s]?\d{1}[A-Z]{2}$/.test(newValue.trim())) {
      return newValue.trim().substring(0, 5);
    } else {
      return newValue.trim();
    }
  }
};

export {
  convertUTCtoUserLocalTimeZone,
  getCountryNameByCountryCode,
  getCurrentGMT,
  dateMapBetweenDays,
  dateFilterInDays,
  getUserGMT,
  compareArrayElements,
  filterDate,
  createSnackBar,
  isObjectEmpty,
  postalCodePatternValidation,
  checkObjectExist,
};
